'use client'

import { APPLE_APP_ID } from '@/config/site-meta'

import { useEffect } from 'react'

import { usePathname } from 'next/navigation'

/**
 * Keeps the Smart App Banner's `app-argument` pointed at the URL the visitor
 * is actually on, so tapping "Open" deep-links there instead of the app's
 * default landing screen. The base tag is set statically by the internal
 * and technician segment layouts (config/site-meta) (SSR'd so Safari can read it before any JS
 * runs); this only refines the argument once the router knows the real
 * path, which keeps the layout itself statically rendered rather than
 * forcing every route dynamic via `headers()` the way a per-request
 * `generateMetadata` would.
 */
export function AppleSmartAppBannerSync() {
  const pathname = usePathname()

  useEffect(() => {
    const meta = document.querySelector('meta[name="apple-itunes-app"]')
    if (!meta) return
    // The content is comma-delimited, so the URL is encoded; the origin is
    // the page's own so staging deep-links to staging.
    const url = `${window.location.origin}${pathname}${window.location.search}`
    meta.setAttribute(
      'content',
      `app-id=${APPLE_APP_ID}, app-argument=${encodeURIComponent(url)}`
    )
  }, [pathname])

  return null
}
